import PropTypes from 'prop-types';
import clsx from 'clsx';
import Icon from '@/components/Icon';
import Link from '@/components/Link';

const defaultProps = {
  link: '',
  icon: '',
  children: null,
};

const propTypes = {
  link: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.node,
};

export default function Card({ link, icon, children }) {
  const hasLink = link !== '';
  const hasIcon = icon !== '';

  let content = (
    <div className="flex flex-col md:flex-row md:space-x-6 lg:space-x-8">
      {hasIcon && (
        <div className="relative flex w-full items-center rounded-l-lg pt-4 pl-8 md:w-28 md:justify-center md:pt-0 md:pl-0 lg:rounded-l-xl xl:rounded-l-2xl">
          <div className="relative z-10 w-20 text-green-500 md:ml-5">
            <Icon name={icon} />
          </div>
          <div className="absolute inset-0 z-0 w-full bg-gradient-to-b from-green-100 to-white md:w-3/4" />
        </div>
      )}
      <div className="flex-1 px-8 pt-3 pb-8 md:py-10 md:px-0">{children}</div>
    </div>
  );

  if (hasLink) {
    content = <Link href={link}>{content}</Link>;
  }

  return (
    <div
      className={clsx(
        'relative flex items-center overflow-hidden rounded-lg bg-white shadow hover:shadow-xl lg:rounded-xl xl:rounded-2xl',
        hasLink &&
          'relative transform transition-all duration-500 ease-in-out hover:-translate-y-1'
      )}
    >
      {content}
    </div>
  );
}

Card.defaultProps = defaultProps;
Card.propTypes = propTypes;
